import {
    GET_SUB_MODULE_MASTER_SUCCESS,
    GET_SUB_MODULE_MASTER_FAILED,
    LOADING_GET_SUB_MODULE_MASTER,
    NETWORK_ERROR_GET_SUB_MODULE_MASTER
} from "../types/index";
import { adminServices } from "../../config/axios";

const adminGetSubModuleMaster =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GET_SUB_MODULE_MASTER });
        await adminServices
            .post("getSubModulemaster", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: GET_SUB_MODULE_MASTER_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: GET_SUB_MODULE_MASTER_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GET_SUB_MODULE_MASTER,
                    payload: err
                });
            });
    };

export { adminGetSubModuleMaster };
